import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';

function StatsItem(props) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <span
        style={{
          fontSize: '15px',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          marginBottom: '10px',
        }}
      >
        {props.title}
      </span>
      <span style={{ fontSize: '15px' }}>{props.value}</span>
    </div>
  );
}

export default function PlacementTestReportTestDialogStats(props) {
  const startDate = moment(props.data.startedAt);
  const endDate = moment(get(props.data, 'completedAt', null));
  const executionTime = endDate ? moment.duration(endDate.diff(startDate)).format('*hh:mm:ss') : null;
  const totalAnsweredItems = get(props.data, 'answeredItems', []).length;
  const correctAnswers = get(props.data, 'answeredItems', []).filter((answer) => answer.correct).length;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {get(props.data, 'reachedLevel.course', false) && (
        <StatsItem title="Level" value={get(props.data.reachedLevel, 'course.name')} />
      )}
      <StatsItem title="Execution Date" value={moment(get(props.data, 'startedAt')).format('DD/MM/YYYY')} />
      {executionTime && <StatsItem title="Execution Time" value={executionTime} />}
      <StatsItem
        title="Hits"
        value={
          totalAnsweredItems > 0
            ? `${correctAnswers}/${totalAnsweredItems} (${((correctAnswers / totalAnsweredItems) * 100).toFixed(1)}%)`
            : `${correctAnswers}/${totalAnsweredItems}`
        }
      />
    </div>
  );
}

PlacementTestReportTestDialogStats.propTypes = {
  data: PropTypes.object.isRequired,
};
